// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d4b08026","453":"32f32b88","455":"5c9d12b4","977":"5f7839a7"}[chunkId] + ".chunk.js";
};